<template>
  <div class="poster" v-if="painting">
    <vue-canvas-poster :widthPixels="750" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
  </div>
</template>

<script>
// https://sunniejs.github.io/vue-canvas-poster/
import { mapGetters } from 'vuex'
import { Icon, Toast } from 'vant'
import { VueCanvasPoster } from 'vue-canvas-poster'
import { padding } from '@/utils/index'

export default {
  name: 'home',
  components: {
    [Icon.name]: Icon,
    VueCanvasPoster
  },
  props: {
    posterData: {
      type: Object
    }
  },
  data () {
    return {
      backgroundImg: null,
      painting: null
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ])
  },
  created () {
  },
  methods: {
    renderByBg (img) {
      this.backgroundImg = img
      this.render()
    },
    render () {
      if (!this.backgroundImg) {
        Toast('海报生成错误')
      }

      this.painting = {
        width: '750px',
        height: '1334px',
        background: this.backgroundImg,
        // background: '#f4f5f7',
        views: [
          {
            type: 'rect',
            css: {
              color: '#fff',
              bottom: '35px',
              left: '25px',
              borderRadius: '10px',
              width: '700px',
              height: '300px'
            }
          },
          ...this.renerUserInfo(25, 25),
          ...this.renderClzzInfo(280, 60),
          ...this.renderEnrollInfo(105, 60),
          ...this.renderQrcode(100, 45)
        ]
      }
    },
    renerUserInfo (top, left) {
      return [
        {
          type: 'image', // 头像
          url: this.userprofile.avatar_url,
          css: {
            top: `${top}px`,
            left: `${left}px`,
            borderRadius: '60px',
            width: '100px',
            height: '100px'
          }
        },
        {
          type: 'text',
          text: `我是${this.userprofile.nickname}`,
          css: [
            {
              top: `${top + 10}px`,
              left: `${left + 115}px`,
              fontSize: '28px',
              // fontWeight: '500',
              color: '#fff'
            }
          ]
        },
        // {
        //   type: 'text',
        //   text: `我已报名${this.posterData.clazz_name}`,
        //   css: [
        //     {
        //       top: `${top + 32}px`,
        //       left: `${left + 115}px`,
        //       fontSize: '28px',
        //       // fontWeight: '500',
        //       color: '#fff'
        //     }
        //   ]
        // },
        {
          type: 'text',
          text: `邀请你和我一起坚持跑步${this.posterData.day_num}天`,
          css: [
            {
              top: `${top + 55}px`,
              left: `${left + 115}px`,
              fontSize: '28px',
              // fontWeight: '500',
              color: '#fff'
            }
          ]
        }
      ]
    },
    renderClzzInfo (bottom, left) {
      return [
        {
          type: 'text',
          text: this.posterData.clazz_name,
          css: [
            {
              bottom: `${bottom}px`,
              left: `${left}px`,
              fontSize: '32px',
              fontWeight: '600',
              color: '#000'
            }
          ]
        },
        {
          type: 'text',
          text: `${this.posterData.day_num}天`,
          css: [
            {
              bottom: `${bottom - 70}px`,
              left: `${left}px`,
              fontSize: '40px',
              color: '#000'
            }
          ]
        },
        {
          type: 'rect',
          css: {
            color: '#B83E34',
            bottom: `${bottom - 130}px`,
            left: `${left - 12}px`,
            borderRadius: '20px',
            width: '130px',
            height: '40px'
          }
        },
        {
          type: 'text',
          text: '坚持跑步',
          css: [
            {
              bottom: `${bottom - 118}px`,
              left: `${left}px`,
              fontSize: '26px',
              color: '#fff'
            }
          ]
        },
        {
          type: 'text',
          text: `${this.posterData.day_distance}KM`,
          css: [
            {
              bottom: `${bottom - 70}px`,
              left: `${left + 170}px`,
              fontSize: '40px',
              color: '#000'
            }
          ]
        },
        {
          type: 'rect',
          css: {
            color: '#B83E34',
            bottom: `${bottom - 130}px`,
            left: `${left - 12 + 170}px`,
            borderRadius: '20px',
            width: '130px',
            height: '40px'
          }
        },
        {
          type: 'text',
          text: '每日目标',
          css: [
            {
              bottom: `${bottom - 118}px`,
              left: `${left + 170}px`,
              fontSize: '26px',
              color: '#fff'
            }
          ]
        },
        {
          type: 'text',
          text: '健康无价',
          css: [
            {
              bottom: `${bottom - 70}px`,
              left: `${left + 325}px`,
              fontSize: '36px',
              color: '#000'
            }
          ]
        },
        {
          type: 'rect',
          css: {
            color: '#B83E34',
            bottom: `${bottom - 130}px`,
            left: `${left - 12 + 340}px`,
            borderRadius: '20px',
            width: '130px',
            height: '40px'
          }
        },
        {
          type: 'text',
          text: '完赛奖牌',
          css: [
            {
              bottom: `${bottom - 118}px`,
              left: `${left + 340}px`,
              fontSize: '26px',
              color: '#fff'
            }
          ]
        }
      ]
    },
    renderEnrollInfo (bottom, left) {
      return [
        {
          type: 'text',
          text: `报名时间: 即日-${this.posterData.enroll_end_time}`,
          css: [
            {
              bottom: `${bottom}px`,
              left: `${left}px`,
              fontSize: '20px',
              color: '#000'
            }
          ]
        },
        {
          type: 'text',
          text: `打卡时间: ${this.posterData.join_start_time}-${this.posterData.join_end_time}`,
          css: [
            {
              bottom: `${bottom - 32}px`,
              left: `${left}px`,
              fontSize: '20px',
              color: '#000'
            }
          ]
        }
      ]
    },
    renderQrcode (bottom, right) {
      return [
        {
          type: 'qrcode',
          content: `http://running.codeeper.com${process.env.VUE_APP_ROUTER_BASE}clazz/${this.posterData.clazz_id}?f=${this.posterData.shareUser}`,
          css: {
            bottom: `${bottom}px`,
            right: `${right}px`,
            color: '#000',
            width: '150px',
            height: '150px'
          }
        },
        {
          type: 'text',
          text: '识别二维码立即报名',
          css: [
            {
              bottom: `${bottom - 35}px`,
              right: `${right - 5}px`,
              fontSize: '18px',
              color: '#696969'
            }
          ]
        }
      ]
    },
    success (src) {
      this.$emit('success', src)
    },
    fail (err) {
      this.$emit('fail', err)
    }
  }
}
</script>
